import { Grid } from "@material-ui/core";

export type { GridProps as IGridProps } from "@material-ui/core";

export default Grid;
